import React from 'react';
import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { vaultSecretsApiRef } from './api';
import { VaultSecretsClient } from './api';

export const vaultSecretsPlugin = createPlugin({
  id: 'vault-secrets',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: vaultSecretsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new VaultSecretsClient({
          discoveryApi,
          fetchApi,
          identityApi,
        }),
    }),
  ],
});

// Export the routable extension for plugin installation
export const VaultSecretsPageExtension = vaultSecretsPlugin.provide(
  createRoutableExtension({
    name: 'VaultSecretsPage',
    component: () =>
      import('./components/VaultSecretsPage').then(m => m.VaultSecretsPage),
    mountPoint: rootRouteRef,
  }),
);

// Export a simple component wrapper for direct use in routes
// This avoids the AppProvider context issue
export const VaultSecretsPage = () => {
  const LazyComponent = React.lazy(() =>
    import('./components/VaultSecretsPage').then(module => ({
      default: module.VaultSecretsPage,
    }))
  );

  return (
    <React.Suspense fallback={<div>Loading Vault Secrets...</div>}>
      <LazyComponent />
    </React.Suspense>
  );
};